import { Component } from '@angular/core';

@Component({
    selector: 'app-galleria',
    imports: [],
    templateUrl: './galleria.component.html',
    styleUrl: './galleria.component.css'
})
export class GalleriaComponent {

}
